import React from 'react';
import { useNavConfigContext } from '../Context/index.js';
import SelectedTab from './Tab/SelectedTab.js';
import Tabs from './Tabs.js';

var Menu = function Menu() {
  var _useNavConfigContext = useNavConfigContext(),
    isMobileView = _useNavConfigContext.isMobileView;
  return isMobileView ? /*#__PURE__*/React.createElement(SelectedTab, null) : /*#__PURE__*/React.createElement(Tabs, null);
};

export { Menu as default };
